import { Action } from "@ngrx/store";

export const GET_INSURANCE_STATUS = '[Insurance Status] Get Insurance Status';
export const GET_INSURANCE_STATUS_SUCCESS = '[Insurance Status] Get Insurance Status Success';
export const GET_INSURANCE_STATUS_FAIL = '[Insurance Status] Get Insurance Status Fail';
export const CLEAR_INSURANCE_STATUS = '[Insurance Status] Clear Insurance Status';
export const RESET_INSURANCE_STATUS_CRUD = '[Insurance Status] Reset CRUD';

export const UPDATE_INSURANCE_STATUS = '[Insurance Status] Update Insurance Status';
export const UPDATE_INSURANCE_STATUS_SUCCESS = '[Insurance Status] Update Insurance Status Success';
export const UPDATE_INSURANCE_STATUS_FAIL = '[Insurance Status] Update Insurance Status Fail';

export const ADD_INSURANCE_STATUS = '[Insurance Status] Add Insurance Status';
export const ADD_INSURANCE_STATUS_SUCCESS = '[Insurance Status] Add Insurance Status Success';
export const ADD_INSURANCE_STATUS_FAIL = '[Insurance Status] Add Insurance Status Fail';

export const GET_CAPITAL_RENEWAL_STATUS = '[Capital Renewal Status] Get Capital Renewal Status';
export const GET_CAPITAL_RENEWAL_STATUS_SUCCESS = '[Capital Renewal Status] Get Capital Renewal Status Success';
export const GET_CAPITAL_RENEWAL_STATUS_FAIL = '[Capital Renewal Status] Get Capital Renewal Status Fail';
export const CLEAR_CAPITAL_RENEWAL_STATUS = '[Capital Renewal Status] Clear Capital Renewal Status';

export class GetInsuranceStatus implements Action {
  readonly type = GET_INSURANCE_STATUS;
  constructor(public payload: any = null) { }
}

export class GetInsuranceStatusSuccess implements Action {
  readonly type = GET_INSURANCE_STATUS_SUCCESS;
  constructor(public payload: any = null) { }
}

export class GetInsuranceStatusFail implements Action {
  readonly type = GET_INSURANCE_STATUS_FAIL;
  constructor(public payload: any = null) { }
}

export class ClearInsuranceStatus implements Action {
  readonly type = CLEAR_INSURANCE_STATUS;
  constructor(public payload: any = null) { }
}

export class ResetInsuranceStatusCRUD implements Action {
  readonly type = RESET_INSURANCE_STATUS_CRUD;
  constructor(public payload: any = null) { }
}

export class UpdateInsuranceStatus implements Action {
  readonly type = UPDATE_INSURANCE_STATUS;
  constructor(public payload: any) { }
}

export class UpdateInsuranceStatusSuccess implements Action {
  readonly type = UPDATE_INSURANCE_STATUS_SUCCESS;
  constructor(public payload: any = null) { }
}

export class UpdateInsuranceStatusFail implements Action {
  readonly type = UPDATE_INSURANCE_STATUS_FAIL;
  constructor(public payload: any = null) { }
}

export class AddInsuranceStatus implements Action {
  readonly type = ADD_INSURANCE_STATUS;
  constructor(public payload: any) { }
}

export class AddInsuranceStatusSuccess implements Action {
  readonly type = ADD_INSURANCE_STATUS_SUCCESS;
  constructor(public payload: any = null) { }
}

export class AddInsuranceStatusFail implements Action {
  readonly type = ADD_INSURANCE_STATUS_FAIL;
  constructor(public payload: any = null) { }
}

export class GetCapitalRenewalStatus implements Action {
  readonly type = GET_CAPITAL_RENEWAL_STATUS;
  constructor(public payload: any = null) { }
}

export class GetCapitalRenewalStatusSuccess implements Action {
  readonly type = GET_CAPITAL_RENEWAL_STATUS_SUCCESS;
  constructor(public payload: any = null) { }
}

export class GetCapitalRenewalStatusFail implements Action {
  readonly type = GET_CAPITAL_RENEWAL_STATUS_FAIL;
  constructor(public payload: any = null) { }
}

export class ClearCapitalRenewalStatus implements Action {
  readonly type = CLEAR_CAPITAL_RENEWAL_STATUS;
  constructor(public payload: any = null) { }
}

export type CapitalRenewalStatusActions =
  | GetInsuranceStatus
  | GetInsuranceStatusSuccess
  | GetInsuranceStatusFail
  | ClearInsuranceStatus
  | ResetInsuranceStatusCRUD
  | UpdateInsuranceStatus
  | UpdateInsuranceStatusSuccess
  | UpdateInsuranceStatusFail
  | AddInsuranceStatus
  | AddInsuranceStatusSuccess
  | AddInsuranceStatusFail
  | GetCapitalRenewalStatus
  | GetCapitalRenewalStatusSuccess
  | GetCapitalRenewalStatusFail
  | ClearCapitalRenewalStatus
  ;